import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hf9zambpa: FaireProductEntity = {
  token: "p_4hf9zambpa",
  type: "product",
  name: "Cabin Retreat - Wax Melts",
  brandName: "Savvy Handcrafts",
  imageUrl:
    "https://cdn.faire.com/fastly/9799211404860cdcf756eb5281e2b68d38e3886822258a9672fa5401378d90a8.jpeg",
  priceDollars: 3.49,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c170befa0bb7246584d82edb84e4563ab37234806646b7307936ae08b7e04eec.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
